module.exports = __webpack_public_path__ + "img/icon1.db3435b3.svg";